import { useParams, usePathname } from 'next/navigation';

// Lib
import { NO_ACTIVE_SOCIAL_PROFILE } from '@/lib/routes/privateRoutes';
import { pagesWithoutSocialProfile } from '@/lib/middleware/accessControl/pagesWithoutSocialProfile';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';
import useSocialProfiles from '@/hooks/swr/useSocialProfiles';

export const useRequiresProfile = () => {
    const params = useParams();
    const pathname = usePathname();

    /**
     * Get the activated social profiles
     */
    const { activatedSocialProfiles } = useSocialProfiles({ revalidateIfStale: false });

    /**
     * Replace url parameters with the real value
     */
    const formattedUrl = formatUrls(pagesWithoutSocialProfile, params);

    /**
     * Check if the user has access to the page
     */
    const noAccess = !activatedSocialProfiles.length && !formattedUrl.includes(pathname);

    return { hasAccess: !noAccess, redirect_url: NO_ACTIVE_SOCIAL_PROFILE };
};
